export default __webpack_public_path__ + "static/media/Summer_Drapes_Btn.72bf471b.jpg";